import { ApiBase } from "~/extensions/api";
import { myPageStore } from "~/store/MyPageStore";
import { DeleteSaveListCommand } from "./commands/DeleteSaveListCommand";
import { FindAppliedListCommand } from "./commands/FindAppliedListCommand";
import { store } from "src/pages/taikyo/store/TaikyoStore";
export class TaikyoNotificationApi extends ApiBase {
    loadFlowGuideText() {
        return this.api.get(`message/taikyoNotification/flow/${store.selectRoomSb}`);
    }
    loadDesiredDatePrecautionsText() {
        return this.api.get("message/desiredDate/precautions");
    }
    getFlowGuideItems() {
        return this.api.get("taikyoNotification/getFlow");
    }
    findNotificationInfo(command) {
        return this.request(command);
    }
    findNotificationForInput(command) {
        return this.request(command);
    }
    insertSave(command) {
        return this.request(command);
    }
    insertNotification(command) {
        return this.request(command);
    }
    insertFile(command) {
        return this.request(command);
    }
    deleteFile(command) {
        return this.request(command);
    }
    getSaveList() {
        return this.api.get(`taikyonotification/save/list/find/${myPageStore.personal.userCd}`);
    }
    deleteSaveList(bulkTaikyoNo) {
        let command = new DeleteSaveListCommand(bulkTaikyoNo);
        return this.request(command);
    }
    getAppliedList(userCd) {
        let command = new FindAppliedListCommand(userCd);
        return this.request(command);
    }
}
